'use client'

import { useEffect } from 'react'
import Container from '@/components/layout/Container'
import Button from '@/components/ui/Button'

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: Props) {
  useEffect(() => {
    // Surface the error to the server logs in development; replace with your
    // error-tracking integration (Sentry, Honeybadger, etc.) when wired up.
    console.error(error)
  }, [error])

  return (
    <section className="flex min-h-[70vh] items-center py-section">
      <Container>
        <div className="mx-auto flex max-w-2xl flex-col items-center gap-6 text-center">
          <p className="text-xs font-medium uppercase tracking-widest text-accent">500</p>
          <h1 className="text-balance text-4xl font-semibold leading-[1.1] tracking-tight text-fg sm:text-5xl md:text-6xl">
            Something went wrong.
          </h1>
          <p className="text-lg leading-relaxed text-muted">
            The page hit an unexpected error. You can try again, or head back home and we&apos;ll
            sort it out.
          </p>
          {error.digest && <p className="font-mono text-xs text-muted/70">Ref: {error.digest}</p>}
          <div className="mt-4 flex flex-wrap justify-center gap-4">
            <Button onClick={() => reset()} variant="primary" size="lg">
              Try again
            </Button>
            <Button href="/" variant="secondary" size="lg">
              Back to home
            </Button>
          </div>
        </div>
      </Container>
    </section>
  )
}
